module.exports = __webpack_public_path__ + "img/basketball-icon-red.7c9e1f13.png";